import { render, staticRenderFns } from "./LinkCheckoutsDifferentPrices.vue?vue&type=template&id=4471408e&scoped=true&"
import script from "./LinkCheckoutsDifferentPrices.vue?vue&type=script&lang=js&"
export * from "./LinkCheckoutsDifferentPrices.vue?vue&type=script&lang=js&"
import style0 from "./LinkCheckoutsDifferentPrices.vue?vue&type=style&index=0&id=4471408e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4471408e",
  null
  
)

export default component.exports